import { render, staticRenderFns } from "./GoodsFormPage.vue?vue&type=template&id=f65565e6&"
import script from "./GoodsFormPage.vue?vue&type=script&lang=js&"
export * from "./GoodsFormPage.vue?vue&type=script&lang=js&"
import style0 from "./GoodsFormPage.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports